import {IAccountingState, initialAccountingState} from "../../state/accounting/accounting.state";
import {AccountingActions, EAccountingActions} from "../../actions/accounting/accounting.actions";

export const accountingReducers = (
  state = initialAccountingState,
    action: AccountingActions
):IAccountingState => {
  switch (action.type) {
    case EAccountingActions.GetAccounts:
      return {
        ...state
      };
    case EAccountingActions.GetAccountsSuccess:
      return {
        ...state,
        data:action.payload,
        isLoaded: true
      };
    case EAccountingActions.GetAccountsFailure:
      return {
        ...state,
        data:[],
        isLoaded: false
      };
    default:
      return state;
  }
};



/*
export const tasksListReducers = (
  state = initialTasksListState,
  action: TasksActions
):ITasksListState =>{
  switch (action.type) {
    case ETasksActions.GetTasksList:
      return {
        ...state
      };
    case ETasksActions.GetTasksListSuccess:
      return {
        ...state,
        tasks:action.payload,
        isLoaded:true
      };
    case ETasksActions.GetTasksListFailure:
      return {
        ...state,
        isLoaded:false
      };

    default:
      return state;
  }
};
 */
